import { InputCurrency } from '@evaneos/b2b-ui/legacy';
import cx from 'classnames';
import { useField } from 'formik';
import { ChangeEvent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { AllTranslationKeys } from '../../../../../shared/intl/types';
import { SidePanelViewMode } from '../../../SidePanel/types';

import s from './ContractFormElements.css';

interface Props {
    name: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    label?: AllTranslationKeys;
    description?: AllTranslationKeys;
    disabled?: boolean;
    containerClassName?: string;
    labelClassName?: string;
    currency?: string;
    viewMode?: SidePanelViewMode;
}

export const NumberFormInput = ({
    onChange,
    label,
    description,
    containerClassName,
    labelClassName,
    ...props
}: Props): JSX.Element => {
    const [field, meta] = useField(props.name);
    const intl = useIntl();

    return (
        <div className={containerClassName ? containerClassName : s.inputContainer}>
            {label && (
                <div
                    className={cx(labelClassName, s.labelContainer)}
                    {...(props.viewMode && { 'data-contract-view': props.viewMode })}
                >
                    <label htmlFor={props.name}>
                        <FormattedMessage id={label} />
                    </label>
                    {description && (
                        <p className={s.inputDescription}>
                            <FormattedMessage id={description} />
                        </p>
                    )}
                </div>
            )}
            <InputCurrency
                {...field}
                {...props}
                currency={props.currency}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChange?.(event);
                    field.onChange(event);
                }}
                type="number"
                className={s.inputCurrency}
                errorText={
                    meta.error && meta.touched
                        ? intl.formatMessage({
                              id: meta.error as AllTranslationKeys,
                          })
                        : undefined
                }
                error={!!meta.error && meta.touched}
                data-testid={props.name}
            />
        </div>
    );
};
